import { APPLICATION_ENVIRONMENT } from '~~/constants/env';
import {
  PARTNERS_MOCK_COOKIE,
  PARTNERS_MOCK_DATA,
  PARTNERS_MOCK_OFF,
  PARTNERS_MOCK_QUERY_PARAMETER,
} from '~~/constants/partnersMockData';
import type { MockedPartnersData } from '~~/types/partnersMock/partnersMock';

/**
 * Lets non-production environments preview Partners states with `?partnersMock=<key>`
 * (see PARTNERS_MOCK_DATA). The choice is kept in a session cookie, so it survives
 * navigation and is the same during SSR and on the client; `?partnersMock=off` clears it.
 */
export const useExpondoPartnersMock = () => {

  const { public: publicConfig } = useRuntimeConfig();
  const isAvailable = publicConfig.applicationEnvironment !== APPLICATION_ENVIRONMENT.PRODUCTION;

  const mockKey = useCookie<string | null>(PARTNERS_MOCK_COOKIE, { default: () => null });

  const rememberMockKeyFromQuery = () => {

    const queryValue = useRoute().query[PARTNERS_MOCK_QUERY_PARAMETER];

    if (typeof queryValue !== 'string') {

      return;

    }

    mockKey.value = queryValue === PARTNERS_MOCK_OFF ? null : queryValue;

  };

  if (isAvailable) {

    rememberMockKeyFromQuery();

  }

  const mockedPartnersData = computed<MockedPartnersData | null>(() =>
    isAvailable && mockKey.value ? PARTNERS_MOCK_DATA[mockKey.value] ?? null : null,
  );

  const shouldUseMockData = computed(() => mockedPartnersData.value !== null);

  return {
    shouldUseMockData,
    mockedPartnersData,
  };

};
